export default function xhrSend(options, callback) {
  let xhr = new XMLHttpRequest();

  xhr.open(options.method, options.url);

  let timeout = options.timeout;
  let timeoutId;

  if (options.headers != null) {
    for (let name in options.headers) {
      xhr.setRequestHeader(name, options.headers[name]);
    }
  }

  let finish = (statusText, responseText) => {
    clearTimeout(timeoutId);

    xhr.onreadystatechange = null;

    if (callback) {
      callback(statusText, responseText, {
        statusCode: xhr.status,
        responseText: responseText,
        xhr: xhr
      });
    }
  };

  let resetXHRTimeout = function() {
    if (timeout != null) {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        xhr.abort();

        finish('timeout', null);
      }, options.timeout);
    }
  };

  resetXHRTimeout();

  xhr.onreadystatechange = () => {
    let readyState = xhr.readyState;

    if (readyState === /*OPENED*/1) {
      return;
    }

    if (readyState === /*HEADERS_RECEIVED*/2) {
      // reset timeout with different value
      resetXHRTimeout();
    }

    if (readyState === /*LOADING*/3) {
      // reset timeout with different value (every time!)
      resetXHRTimeout();
    }

    if (readyState === /*DONE*/4) {
      let statusCode = xhr.status;

      if (statusCode === 0) {
        finish('error', null);
        return;
      }

      if (statusCode === 200 || statusCode === 204) {
        finish('success', xhr.responseText);
        return;
      }
      if (statusCode === 429) {
        finish('rate_limit', null);
        return;
      }
      if (statusCode === 304) {
        finish('not_modified', null);
        return;
      }

      finish('error', xhr.responseText);
      return;
    }
  };

  xhr.send(options.data);

  return {
    abort: () => {
      if (xhr.onreadystatechange) {
        xhr.abort();

        finish('abort', null);
      }
    }
  };
}
